// sapi-admin/src/contexts/SoundContext.jsx
import React, { createContext, useContext, useState } from 'react';

const SoundContext = createContext();

export function useSound() {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSound must be used within SoundProvider');
  }
  return context;
}

// Récupérer la préférence depuis localStorage
const getSoundPreference = () => {
  const saved = localStorage.getItem('sapi_admin_sound_enabled');
  return saved === null ? true : saved === 'true';
};

// Sauvegarder la préférence dans localStorage
const setSoundPreference = (enabled) => {
  localStorage.setItem('sapi_admin_sound_enabled', enabled);
};

export function SoundProvider({ children }) {
  const [soundEnabled, setSoundEnabled] = useState(getSoundPreference());

  const toggleSound = () => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    setSoundPreference(newValue);
  };

  return (
    <SoundContext.Provider value={{ soundEnabled, toggleSound, setSoundEnabled }}>
      {children}
    </SoundContext.Provider>
  );
}